import React, { Component } from "react";
import Wrp from '../../../../../../../hoc/Wrp/Wrp';
import 'react-datetime/css/react-datetime.css';
import FormInputFields from "../../../../../../FormInputFields";
import StepsFormatTag from '../StepsFormatTag';
import { isSet } from "../../../../../../../Utils/CommonFunctions";

class RepeatEndsOn extends Component {

  constructor(props) {
    super(props);
    this.state = {
        repeatEnds:{
            endsOn:'Never',
            endsOnDate:'',
            afterNtimes:1
        }
      
    }
  }
  repeatEndsChangeHandler = (repeatEnds,wthis)=>{
    const {actionChangeHandler,reminderJson} = this.props;
    // console.log({...reminderJson.repeatEndsObj,key:repeatEnds});
    // actionChangeHandler(wthis,'repeatEndsObj',{...reminderJson.repeatEndsObj,key:repeatEnds});
  }
  render() {
    const  {
    reminderJson,
    actionChangeHandler
    } = this.props;
    const repeatEndsArr = ['Never','On','After'];
    const {repeatEnds} =  this.state;
    
    console.log('RepeatsEndDate.....',repeatEnds);
    return (
        <Wrp>
            <div className="form-group">
			    <label className="d-block"> Ends </label> 
                <div className="selectgroup">
                  {repeatEndsArr.map((item,itemIndex)=>{
                    return(
                      <label className="selectgroup-item" key={itemIndex}>
                        <input 
                          type="radio" 
                          name="icon-input"
                          checked={(repeatEnds.endsOn===item)?true:false}
                          className="selectgroup-input" 
                          onChange={e=>this.endsOnChangeHandler(e,'endsOn',item)} />
					    <span className="selectgroup-button selectgroup-button-icon" >{item}</span>
					   </label>
                    )
                   })}
			    </div>
			</div>
            {/* REPEAT ENDS ON OPTION  */}
            {(repeatEnds.endsOn==='On')?
              <div className="form-group">
                <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">{`Date`}</span>
                </div>

                {
                  reminderJson.is_repeat_ends === false?
                  <FormInputFields  
                    type='DatePick'
                    value={repeatEnds.endsOnDate}
                    attributes={{
                      ...this.props.attr.fieldAttributes,
                      putDateFormat:'YYYY-MM-DD',
                      getDateFormat:'YYYY-MM-DD',
                    }}
                    changeHandler={(val)=>this.endsOnChangeHandler({},'endsOnDate',val)}
                  />
                  :
                  <FormInputFields  
                    type='StepsTypeTagForReminder'                    
                    value={isSet(reminderJson.repeat_ends,[]).length>0?reminderJson.repeat_ends[0].name:''}
                    item={{isEditEnable:isSet(reminderJson.repeat_ends,[]).length>0?isSet(reminderJson.repeat_ends[0].is_expression,false)===true?true:false:false}}              
                    changeHandler={(val)=>{ this.props.actionChangeHandler({},'repeat_ends',val,true,false) }}
                    editHandler = {()=>this.props.setFormulaFieldDetails({
                                    value:(isSet(reminderJson.repeat_ends,[]).length)>0?reminderJson.repeat_ends[0].value:'',
                                    //value:(isSet(reminderJson.repeat_ends,[]).length)>0?isSet(reminderJson.repeat_ends[0].is_expression,false)===true?reminderJson.repeat_ends[0].value:reminderJson.repeat_ends[0].variable_name:'',
                                      conValue:isSet(reminderJson.remind_time,[{
                                          name:'',
                                          data_id:'',
                                          is_loop:false,
                                          value:'',
                                          is_window_field:false,
                                          is_variable_or_constant:false,
                                          is_expression:true
                                      }]),
                                      itmValIndex:0,
                                      drillDownOptions:this.props.item.lookupFieldsData.lookupFields.drillDownOptions,                                    
                                      updateValuesChangeHandler:(val)=>this.props.actionChangeHandlerForFormula({},'repeat_ends',val,true,true),
                                    conIndex:0,
                                },true)}
                  />
                }

                

                {
                  this.props.screen === 'Steps'?
                  <StepsFormatTag {...this.props} handlerObj={{field_name:'repeat_ends'}} />
                  :
                  <></>
                }


                {/* <Datetime
                  value={repeatEnds.endsOnDate}
                  timeFormat={false}
                  inputProps={{...this.props.attr.fieldAttributes,autoComplete:'off'}}
                  onChange={this.onDateChangeHandler}
                  dateFormat= {getDateFormat()}
                /> */}
              </div>
            </div>
            :(repeatEnds.endsOn==='After')?
              <div className="form-group">
                <div className="input-group">
                  <input type="number" 
                    name="" 
                    className="form-control" 
                    value={repeatEnds.afterNtimes} 
                    onChange={e=>this.endsOnChangeHandler(e,'afterNtimes',e.target.value)}/>
                  <div className="input-group-append">
                    <span className="input-group-text">{`Times`} </span>
                  </div> 
                </div>	
            </div>
            :''}
     </Wrp>       
    );
  }
  componentDidMount = ()=>{
    //   this.updateRepeatEndsOnStats();
    this.updateRepeatEndsOptions();
  }
  componentDidUpdate = (prevProps)=>{
    if(prevProps.reminderJson!==this.props.reminderJson){
      this.updateRepeatEndsOptions();
    }
   
  }

  updateRepeatEndsOptions = ()=>{
    const {reminderJson} = this.props;
    let updateState = this.state.repeatEnds;
    let repeat_ends = reminderJson.repeat_ends;
    let is_repeat_ends = reminderJson.is_repeat_ends;
    if(is_repeat_ends === false){
      if(repeat_ends.indexOf('On')!==-1){
        repeat_ends = repeat_ends.replace('On','');
        repeat_ends = repeat_ends.trim();
        updateState.endsOn = 'On';
        updateState.endsOnDate = repeat_ends;
      }else if(repeat_ends.indexOf('After')!==-1){
        repeat_ends = repeat_ends.replace('After','');
        repeat_ends = repeat_ends.replace('Times','');
        updateState.endsOn = 'After';
        repeat_ends = repeat_ends.trim();
        updateState.afterNtimes = repeat_ends;
      }
    }else{
      updateState.endsOn = 'On'; 
    }
    
    this.setState({repeatEnds: updateState});
  }
//   updateRepeatEndsOnStats = ()=>{
    
//   }
  // componentDidUpdate = (prevProps,prevState) =>{
  //   // this.updateRepeatEndsOnStats();
  //   const {reminderJson} = this.props;
  //     let updateState = this.state.repeatEnds;
  //     let repeat_ends = reminderJson.repeat_ends;
  //     if(repeat_ends.indexOf('On')!==-1){
  //       repeat_ends = repeat_ends.replace('On','');
  //       repeat_ends = repeat_ends.trim();
  //       updateState.endsOn = 'On';
  //     }else if(repeat_ends.indexOf('After')!==-1){
  //       repeat_ends = repeat_ends.replace('After','');
  //       repeat_ends = repeat_ends.replace('Times','');
  //       updateState.endsOn = 'After';
  //       repeat_ends = repeat_ends.trim();
  //       updateState.afterNtimes = repeat_ends;
  //     }
  //     this.setState(function (prevState) {
  //       if(this.state.repeatEnds!==prevState.repeatEnds){
  //       return {
  //           repeatEnds: updateState
  //       };
  //       }
  //   });
  //   //   this.setState({repeatEnds:updateState});
  // }
  endsOnChangeHandler = async (e,stateField,value)=>{      
      let updateState = this.state.repeatEnds;
      const {reminderJson,actionChangeHandler} = this.props;
      actionChangeHandler(e,'repeat_ends','',true,false);
      updateState[stateField] = value;      
     await this.setState({repeatEnds:updateState});
    //  console.log("updateState",updateState);
     let repeat_ends =  reminderJson.repeat_ends;
     if(updateState.endsOn==='On'){
        repeat_ends = 'On '+updateState.endsOnDate;
     }else if(updateState.endsOn==='After'){
        repeat_ends = 'After '+updateState.afterNtimes+' Times';
     }
    //  console.log('repeat_ends',repeat_ends);
     actionChangeHandler(e,'repeat_ends',repeat_ends);
  }
  // onDateChangeHandler = (moment)=>{
  //   // const {actionChangeHandler} = this.props;
  //   if (typeof moment.format === "function") { 
  //       const date = moment.format('YYYY-MM-DD');
  //       this.endsOnChangeHandler(moment,'endsOnDate',date);
  //     }else{
  //     }  
  //  }
  
}

export default RepeatEndsOn;
